import React from "react";

import OtherActions from "./OtherActions";

const AnthologyOtherActions = React.forwardRef((props, ref) => {
  const { anthology, removeFromParent } = props;

  const handleRemoveClick = anthology => event => {
    event.stopPropagation();
    event.preventDefault();
    removeFromParent(anthology);
  };

  return (
    <OtherActions
      child={anthology}
      ancestors={anthology.parentModules}
      handleRemoveClick={handleRemoveClick(anthology)}
    />
  );
});

export default AnthologyOtherActions;
